import { MedplumClient } from '@medplum/core';
import { resolveSignInRedirect } from './lib/authRedirect';

/**
 * The single MedplumClient for the app (SPEC §10.1 — Medplum is the resource
 * server; Phase 1 uses Medplum-native auth per §16 Q2).
 *
 * `baseUrl` resolves at runtime: a `medplum_base_url` sessionStorage override
 * (handy for pointing a built bundle at a different server), else the
 * `VITE_MEDPLUM_BASE_URL` build env, else the SDK default (Medplum Cloud).
 */
function resolveBaseUrl(): string | undefined {
  try {
    const override = sessionStorage.getItem('medplum_base_url');
    if (override) {
      return override;
    }
  } catch {
    /* sessionStorage unavailable */
  }
  return import.meta.env.VITE_MEDPLUM_BASE_URL || undefined;
}

export const medplum = new MedplumClient({
  baseUrl: resolveBaseUrl(),
  cacheTime: 60_000,
  autoBatchTime: 100,
  onUnauthenticated: () => {
    // A mid-session 401 forces a hard redirect to sign-in (the router/session is
    // no longer trustworthy). Preserve where the user was via `?redirect=`, and
    // route PORTAL sessions to `/portal/signin` (never the clinician `/signin`) so
    // an expired patient session stays in the branded portal flow (issue #154).
    if (typeof window !== 'undefined') {
      const target = resolveSignInRedirect(window.location);
      if (target) {
        window.location.href = target;
      }
    }
  },
});
